<template>
    <div class="container">
        <div class="row">
            <div class="col-12 h-100">
                <form @submit.prevent="hcfCalculatorFormula">
                    <div class="form-group row mt-4">
                        <label for = "laDiameterLabel" class="col-3 col-form-label">
                            {{ laDiameterLabel }}
                        </label>
                        <div class="col-4 pr-2 mt-2">
                            <div class="form-group">
                                <select
                                    class="form-control custom-select btn--select py-0"
                                    id="laDiameterLabel"
                                    v-model="laDiameterDrodownValue" v-on:change="handleChange('laDiameterDrodownValue')">
                                    <option value="">Select Transverse LA Dimension</option>
                                    <option value="8">24-29</option>
                                    <option value="10">30-35</option>
                                    <option value="12">36-41</option>
                                    <option value="14">42-47</option>
                                    <option value="16">48-53</option>
                                    <option value="18">54-59</option>
                                    <option value="20">60-65</option>
                                </select>
                                <p class="text-danger errorMessage" role="alert" v-if="laDiameterErrMsg">{{ laDiameterErromessage }}</p>
                            </div>
                        </div>
                    </div>
                    <!-- 2nd row -->
                    <div class="form-group row mt-4">
                        <label for = "ageHcmDiagnosisLabel" class="col-3 col-form-label">
                            {{ ageHcmDiagnosisLabel }}
                        </label>
                        <div class="col-4 pr-2 mt-2">
                            <div class="form-group">
                                <select
                                    class="form-control custom-select btn--select py-0"
                                    id="ageHcmDiagnosisLabel"
                                  
                                    v-model="ageHCMDropdDownValue"
                                    v-on:change="handleChange('ageHcmDiagnosisLabel')">
                                    <option value="">Select Age at HCM Diagnosis </option>
                                    <option value="0">0-9</option>
                                    <option value="-2">10-19</option>
                                    <option value="-4">20-29</option>
                                    <option value="-6">30-39</option>
                                    <option value="-8">40-49</option>
                                    <option value="-10">50-59</option>
                                    <option value="-12">60-69</option>
                                    <option value="-14">70-79</option>
                                </select>
                                <p class="text-danger errorMessage" role="alert" v-if="ageHCMDErrMsg "> {{ ageHcmDiagnosisErrormessage  }} </p>
                            </div>
                        </div>
                    </div>
                    <!-- 3rd row -->
                    <div class="form-group row mt-4">
                        <label for = "ageClinicalEvaluationLabel" class="col-3 col-form-label">
                            {{ ageClinicalEvaluationLabel }}
                        </label>
                        <div class="col-4 pr-2 mt-2">
                            <div class="form-group">
                                <select
                                    class="form-control custom-select btn--select py-0"
                                    id="ageClinicalEvaluationLabel"
                                    v-model="ageClinicalEvaluationDropdownValue"
                                    v-on:change="handleChange('ageClinicalEvaluationLabel')">
                                    <option value="">Select Age at Clinical Evaluation</option>
                                    <option value="3">10-19</option>
                                    <option value="6">20-29</option>
                                    <option value="9">30-39</option>
                                    <option value="12">40-49</option>
                                    <option value="15">50-59</option>
                                    <option value="18">60-69</option>
                                    <option value="21">70-79</option>
                                </select>
                                <p class="text-danger errorMessage" role="alert" v-if="ageClinicalErrMsg ">{{ageClinicalEvaluationErrormessage  }}</p>
                               
                            </div>
                        </div>
                    </div>
                    <!-- 4th Row -->
                    <div class="form-group row mt-4">
                        <label for="heartFailureSymptomsLabel" class="col-3 col-form-label">
                            {{ heartFailureSymptomsLabel }}
                        </label>
                        <div class="col-4 pr-2 mt-2">
                            <div class="form-group">
                                <div
                                    class="btn-group btn-group-toggle"
                                    data-toggle="buttons">
                                    <label for="no">
                                        <input
                                            type="radio"
                                            name="no"
                                            id="no"
                                            autocomplete="off"
                                            value="0"
                                            checked
                                            v-model.number="heartFailureSymptoms"
                                            aria-label = "NYHA Class II, III, or IV Heart Failure Symptoms No"
                                            />
                                        No
                                    </label>
                                    <label for="yes" class="ml-4">
                                        <input
                                            type="radio"
                                            name="yes"
                                            id="yes"
                                            autocomplete="off"
                                            value="3"
                                            aria-label = "NYHA Class II, III, or IV Heart Failure Symptoms Yes"
                                            v-model.number="heartFailureSymptoms"/>
                                        Yes
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Reset button section -->
                    <div class="col col-md-12 text-center text-lg-left">
                        <input
                            class="btn btn-primary custom-btn"
                            type="submit"
                            value="Calculate Score"
                            key="submit"
                            @click="formValidate"/>
                        <input
                            class="btn btn-outline ml-3"
                            type="reset"
                            key="reset"
                            value="Reset"
                            @click="reset"/>
                    </div>
                    
                    <div class="form-group">
                        <label for="HCMAFScore" class=" col-form-label mt-3" >{{ hcmAfScoreText }} <span
                                  class="abbr" > <abbr id="HCMAFScore" aria-label="HCM-AF Score"
                                      title="HCM-AF Score"></abbr></span> </sup> </label>
                                      <div>
                                        <input class="col-md-8 custom-input-box" id="HCMAFScore" type="text" disabled name="totalValue" :value="totalValue" />
                          </div>
                        <label for="twoYearRiskText" class=" col-form-label mt-3">{{ twoYearRiskText }} <span
                                  class="abbr"> <abbr id="twoYearRiskText" aria-label="Risk of at 2 years(%)"
                                      title="Risk of at 2 years(%)"></abbr></span> </sup> </label>
                                      <div>
                                        <input class="col-md-8 custom-input-box" id="twoYearRiskText" type="text" disabled name="2%" :value="twoPersent" />
                          </div>
                          <label for="fiveYearRiskText" class=" col-form-label mt-3">{{ fiveYearRiskText }}<span
                                  class="abbr"> <abbr id="fiveYearRiskText" aria-label="Risk of at 5 years(%)"
                                      title="Risk of at 5 years(%)"></abbr></span> </sup> </label>
                                      <div>
                                        <input class="col-md-8 custom-input-box" id="fiveYearRiskText" type="text" disabled name="5%" :value="fivePersent" />
                          </div>
                        </div>
                </form>
                <div v-if = "btnTxt" v-html="bottomText">
                </div>
                <div v-if = "recommendationTxt" v-html="riskScoreLabel"></div>
            </div>
        </div>
 
    </div>
</template>
<script>
export default {
    props: {
        laDiameterLabel: {
            type: String,
            default: "",
        },
        ageClinicalEvaluationLabel: {
            type: String,
            default: "",
        },
        ageHcmDiagnosisLabel: {
            type: String,
            default: "",
        },
        heartFailureSymptomsLabel: {
            type: String,
            default: "",
        },
        laDiameterErromessage: {
            type: String,
            default: "",
        },
        ageClinicalEvaluationErrormessage: {
            type: String,
            default: "",
        },
        ageHcmDiagnosisErrormessage: {
            type: String,
            default: "",
        },
        heartFailureSymptomsErrormesage: {
            type: String,
            default: "",
        },
        riskScoreLabel: {
            type: String,
            default: "",
        },
        hcmAfScoreText: {
            type: String,
            default: "",
        },
        twoYearRiskText: {
            type: String,
            default: "",
        },
        fiveYearRiskText: {
            type: String,
            default: "",
        },
        bottomText: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            laDiameterDrodownValue: "",
            ageClinicalEvaluationDropdownValue: "",
            ageHCMDropdDownValue: "",
            heartFailureSymptoms: "0",
            totalValue: "",
            laDiameterErrMsg: false,
            ageClinicalErrMsg: false,
            ageHCMDErrMsg: false,
            totalResultMsg: false,
            twoPersent: "",
            fivePersent: "",
            risk: "",
            recommendationTxt: false,
            btnTxt: false,
            answerList: [
                {
                    label: "low risk",
                    totalScore: 8,
                    riskAF2: 0.4,
                    riskAF5: 1.0
                },
                {
                    label: "low risk",
                    totalScore: 9,
                    riskAF2: 0.5,
                    riskAF5: 1.2
                },
                {
                    label: "low risk",
                    totalScore: 10,
                    riskAF2: 0.6,
                    riskAF5: 1.4
                },
                {
                    label: "low risk",
                    totalScore: 11,
                    riskAF2: 0.7,
                    riskAF5: 1.7
                },
                {
                    label: "low risk",
                    totalScore: 12,
                    riskAF2: 0.9,
                    riskAF5: 2.1
                },
                {
                    label: "low risk",
                    totalScore: 13,
                    riskAF2: 1.0,
                    riskAF5: 2.5
                },
                {
                    label: "low risk",
                    totalScore: 14,
                    riskAF2: 1.3,
                    riskAF5: 3.0
                },
                {
                    label: "low risk",
                    totalScore: 15,
                    riskAF2: 1.5,
                    riskAF5: 3.6
                },
                {
                    label: "low risk",
                    totalScore: 16,
                    riskAF2: 1.8,
                    riskAF5: 4.3
                },
                {
                    label: "low risk",
                    totalScore: 17,
                    riskAF2: 2.2,
                    riskAF5: 5.2
                },
                {
                    label: "intermediate risk",
                    totalScore: 18,
                    riskAF2: 2.6,
                    riskAF5: 6.2
                },
                {
                    label: "intermediate risk",
                    totalScore: 19,
                    riskAF2: 3.1,
                    riskAF5: 7.4
                },
                {
                    label: "intermediate risk",
                    totalScore: 20,
                    riskAF2: 3.8,
                    riskAF5: 8.9
                },
                {
                    label: "intermediate risk",
                    totalScore: 21,
                    riskAF2: 4.5,
                    riskAF5: 10.6
                },
                {
                    label: "high risk",
                    totalScore: 22,
                    riskAF2: 5.4,
                    riskAF5: 12.6
                },
                {
                    label: "high risk",
                    totalScore: 23,
                    riskAF2: 6.5,
                    riskAF5: 15.0
                },
                {
                    label: "high risk",
                    totalScore: 24,
                    riskAF2: 7.8,
                    riskAF5: 17.8
                },
                {
                    label: "high risk",
                    totalScore: 25,
                    riskAF2: 9.3,
                    riskAF5: 21.1
                },
                {
                    label: "high risk",
                    totalScore: 26,
                    riskAF2: 11.1,
                    riskAF5: 24.8
                },
                {
                    label: "high risk",
                    totalScore: 27,
                    riskAF2: 13.3,
                    riskAF5: 29.1
                },
                {
                    label: "high risk",
                    totalScore: 28,
                    riskAF2: 15.7,
                    riskAF5: 33.9
                },
                {
                    label: "high risk",
                    totalScore: 29,
                    riskAF2: 18.7,
                    riskAF5: 39.3
                },
                {
                    label: "high risk",
                    totalScore: 30,
                    riskAF2: 22.0,
                    riskAF5: 45.2
                },
                {
                    label: "high risk",
                    totalScore: 31,
                    riskAF2: 25.9,
                    riskAF5: 51.5
                }
            ]
        };
    },
    methods: {
        hcfCalculatorFormula() {
            if(this.laDiameterDrodownValue !== "" && this.ageClinicalEvaluationDropdownValue !== "" && this.ageHCMDropdDownValue !== "") {
                this.totalValue =
                parseInt(this.laDiameterDrodownValue) +
                parseInt(this.ageClinicalEvaluationDropdownValue) +
                parseInt(this.ageHCMDropdDownValue) +
                parseInt(this.heartFailureSymptoms);
            this.totalValue = this.totalValue > 31 ? "31+" : (this.totalValue < 8 ? 'below 8' : this.totalValue);
            let filteredList = this.answerList.filter(item => item.totalScore === this.totalValue);
            this.twoPersent = this.totalValue === "31+" || this.totalValue === 'below 8' ? null : filteredList[0].riskAF2.toFixed(1)
            this.fivePersent = this.totalValue === "31+" || this.totalValue === 'below 8' ? null : filteredList[0].riskAF5.toFixed(1)

            if (this.totalValue > 21 || this.totalValue === "31+") {
                this.recommendationTxt = true
            } else {
                this.recommendationTxt = false
            }
            this.btnTxt = true
            } else {
                this.totalValue = ""
            }
                
        },
        formValidate() {
            if (this.laDiameterDrodownValue === "") {
                this.laDiameterErrMsg = true;
            }
            if (this.ageClinicalEvaluationDropdownValue === "") {
                this.ageClinicalErrMsg = true;
            }

            if (this.ageHCMDropdDownValue === "") {
                this.ageHCMDErrMsg = true;
            }

            if (
                this.laDiameterErrMsg &&
                this.ageClinicalErrMsg &&
                this.ageHCMDErrMsg
            ) {
                this.totalResultMsg = true;
            }
        },
        handleChange(val) {
            if (val === "laDiameterDrodownValue") {
                if (this.laDiameterDrodownValue === "") {
                    this.laDiameterErrMsg = true;
                } else {
                    this.laDiameterErrMsg = false;
                }
            }

            if (val === "ageClinicalEvaluationLabel") {
                if (this.ageClinicalEvaluationDropdownValue === "") {
                    this.ageClinicalErrMsg = true;
                } else {
                    this.ageClinicalErrMsg = false;
                }
            }

            if (val === 'ageHcmDiagnosisLabel') {
                if (this.ageHCMDropdDownValue === "") {
                    this.ageHCMDErrMsg = true;
                } else {
                    this.ageHCMDErrMsg = false;
                }
            }

        },
        reset() {
            this.laDiameterDrodownValue = "",
                this.ageClinicalEvaluationDropdownValue = "",
                this.ageHCMDropdDownValue = "",
                this.heartFailureSymptoms = "0",
                this.totalValue = "",
                this.laDiameterErrMsg = false,
                this.ageClinicalErrMsg = false,
                this.ageHCMDErrMsg = false,
                this.totalResultMsg = false,
                this.twoPersent = "",
                this.fivePersent = "",
                this.risk = "",
                this.recommendationTxt = false,
                this.btnTxt = false;
        },
    },
};
</script>

<style>
.result {
    font-size: 18px;
}

.custom-input-box {
    background-color: #e9ecef;
    opacity: 1;
    padding: 0.3rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-clip: padding-box;
    border: 1px solid #c4cacf;
    border-radius: 2px;
}

.custom-btn {
    margin-left: -14px;
}
</style>



// WEBPACK FOOTER //
// src/app/components/phd/hcf-calculator.vue